import { DateTime } from "luxon";
import React, { FC } from "react";

import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import Header from "../../../components/Header";
import LoadingScreen from "../../../components/LoadingScreen";
import { useSelector } from "../../../store";
import {
  useDeleteOrganizationInviteMutation,
  useListOrganizationInvitesQuery,
} from "../../../store/pomeriumApi";
import Invite from "./Invite";

const List: FC = () => {
  const [revoke] = useDeleteOrganizationInviteMutation();
  const { organizationId } = useSelector((state) => state.current);

  const {
    data: invites,
    isLoading,
    isFetching,
  } = useListOrganizationInvitesQuery(organizationId, {
    skip: !organizationId,
  });

  if (isLoading || isFetching) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Header title="Invites" breadcrumbs={false} actions={<Invite />} />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Invite Date</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          {!invites?.length && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                Currently No Invites
              </TableCell>
            </TableRow>
          )}
          {invites?.map((invite) => (
            <TableRow
              key={"invite_" + invite.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {invite?.email}
              </TableCell>
              <TableCell>{invite?.role}</TableCell>
              <TableCell>
                {DateTime.fromISO(invite.createdAt).toLocaleString()}
              </TableCell>

              <TableCell>
                <Button
                  key={"reject" + invite.id}
                  color="error"
                  onClick={() =>
                    revoke({
                      organizationId,
                      invitationId: invite.id as string,
                    })
                  }
                >
                  Rescind
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
export default List;
